import clsx from 'clsx';
import React from 'react';

import { useAppContext } from '@contexts/AppContext';
import { Newsletter } from '@utils/backend-api/newsletters';

import NewsletterSignUp from '../NewsletterSignup';
import styles from './middleStyles.module.scss';

interface MiddleProps {
  currentUserAccessLevel: number;
  isLoggedIn: boolean;
  isSubscribed: boolean;
  gdpr: boolean;
  newsletter: Newsletter;
}

const Middle = ({ isSubscribed, newsletter }: MiddleProps) => {
  const { initialCurrentUser, isGdprRequired } = useAppContext();
  const isLoggedIn = !!initialCurrentUser;
  return (
    <div className={styles.mainContainer} id="feed-newsletter-container-middle">
      <div className={clsx(styles.middleContainer, 'container')}>
        <div className={styles.middleWrapper}>
          <div className={styles.newsletterIntro}>
            <div className={styles.newsletterName}>{newsletter.name} Newsletter</div>
            <div className={styles.newsletterDescription}>{newsletter.description}</div>
          </div>
          <div className={styles.newsletterAction}>
            <NewsletterSignUp
              currentUserAccessLevel={initialCurrentUser?.access_level}
              isLoggedIn={isLoggedIn}
              isSubscribed={isSubscribed}
              gdpr={isGdprRequired}
              newsletter={newsletter}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Middle;
